import { inject, Injectable, isDevMode, PLATFORM_ID, REQUEST } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { StringUtils } from '@app/core/utils/string.utils';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private readonly _domain = '.industrybuying.com';
  private readonly _authCookieNames = ['ibx', 'ib_sessionid'];
  private readonly _platformId = inject(PLATFORM_ID);
  private readonly _request = inject(REQUEST, { optional: true });

  constructor() { }

  getCookie(cname: string): string {
    // if (!isPlatformBrowser(this._platformId)) {
    //   console.warn('Cookies cannot be accessed on the server-side');
    //   return '';
    // }

    const name: string = StringUtils.format('{0}=', cname);
    let ca: string[] = [];
    if (isPlatformBrowser(this._platformId)) {
      ca = document.cookie.split(';');
    } else {
      ca = this._request?.headers?.['cookie']?.split(';') ?? [];
    }


    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  setCookie(name: string, value: any, exDays: number = 1) {
    if (!isPlatformBrowser(this._platformId)) {
      console.warn('Cookies cannot be set on the server-side');
      return;
    }

    const d = new Date();
    d.setTime(d.getTime() + exDays * 24 * 60 * 60 * 1000);

    let cookie: string = StringUtils.format(
      '{0}={1};expires={2};path=/;',
      name,
      value,
      d.toUTCString(),
    );
    if (!isDevMode()) {
      cookie += StringUtils.format('domain={0};', this._domain);
    }
    document.cookie = cookie;
  }

  clearCookie(name: string) {
    if (!isPlatformBrowser(this._platformId)) {
      console.warn('Cookies cannot be cleared on the server-side');
      return;
    }

    document.cookie = StringUtils.format(
      '{0}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;',
      name,
    );
  }

  /**
   * Clears auth cookies client-side. Emits both a host-only and a
   * Domain=.industrybuying.com variant since the cookie may have been set
   * with either attribute depending on environment (local vs prod) — the
   * browser ignores whichever variant doesn't match the cookie it actually holds.
   */
  clearAuthCookies(): void {
    if (!isPlatformBrowser(this._platformId)) {
      return;
    }
    this._authCookieNames.forEach((cookieName) => {
      this.clearCookie(cookieName);
      console.log(cookieName, this.getCookie(cookieName));
    });
  }

  private _getAllCookies(): { [key: string]: string } {
    const cookies: { [key: string]: string } = {};
    document.cookie.split('; ').forEach((cookie) => {
      const [name, value] = cookie.split('=');
      cookies[name] = decodeURIComponent(value);
    });
    return cookies;
  }

  getFilteredCookies(prefix: string): { [key: string]: string } {
    const allCookies = this._getAllCookies();
    return Object.keys(allCookies)
      .filter((key) => key.startsWith(prefix))
      .reduce(
        (acc, key) => {
          acc[key] = allCookies[key];
          return acc;
        },
        {} as { [key: string]: string },
      );
  }
}
